module.exports = {

  title: '北大邦智慧课堂校方后台',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true, // 设置 navbar的固定定位

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true // 显示左侧的导航栏顶部的图标
}
